import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ViewChildren, ElementRef, HostListener } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDatepickerInputEvent, MatSelect } from '@angular/material';

import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { CommonService } from 'src/app/core/services/common.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { Subscription, ReplaySubject, Subject } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { NgForm, FormControl } from '@angular/forms';
import { UploadMultiFileComponent } from 'src/app/shared/components/upload-multi-file/upload-multi-file.component';
import { finalize, first, map, takeUntil } from 'rxjs/operators';
import { DeactivationGuarded } from 'src/app/core/guards/confirm-deactivate.guard';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { ApiService } from 'src/app/core/services/api.service';
import Utils from 'src/app/core/services/app-utils';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { AlertEkycComponent } from 'src/app/shared/components/alert-ekyc/alert-ekyc.component';
import { KycService } from 'src/app/core/services/kyc.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Common } from '../../../../../../core/constants/common';


@Component({
  selector: 'app-update-enterprise',
  templateUrl: './update-enterprise.component.html',
  styles: [`
    .status-document {
      color: white;
      background-color: #00857c;
    }

    .text-off-document {
      color: #000000DE;
    }
  `],
  providers: [DatePipe]
})
export class UpdateEnterpriseComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit, DeactivationGuarded {
  @BlockUI() blockUI: NgBlockUI;
  maxDate = new Date();
  minDate = new Date(1899, 12, 1);
  personalId = EnterpriseTypes.PERSONAL;
  oldEnterpriseName;
  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  @ViewChildren('focus') focus;
  @ViewChild(UploadMultiFileComponent, { read: UploadMultiFileComponent, static: false }) uploadMultiFileComponent;
  @ViewChild('enterpriseTypeSelect', { static: false }) enterpriseTypeSelect: MatSelect;
  @ViewChild('certificationTypeSelect', { static: false }) certificationTypeSelect: MatSelect;
  @ViewChild('representativeCertificateSelect', { static: false }) representativeCertificateSelect: MatSelect;
  @ViewChild('citySelect', { static: false }) citySelect: MatSelect;
  @ViewChild('districtSelect', { static: false }) districtSelect: MatSelect;
  @ViewChild('wardSelect', { static: false }) wardSelect: MatSelect;
  @ViewChild('sexSelect1', { static: false }) sexSelect1: MatSelect;
  @ViewChild('sexSelect2', { static: false }) sexSelect2: MatSelect;
  @ViewChild('bankSelect', { static: false }) bankSelect: MatSelect;

  defaultAddress = {
    cityId: null,
    districtId: null,
    wardId: null,
    enterpriseId: null,
    address: '',
    isNewAddress: true
  };
  defaultEnterprises = {
    id: null,
    name: '',
    enterpriseType: null,
    tenantId: 1,
    foreignName: '',
    parentId: null,
    abbreviation: '',
    taxCode: '',
    licenceDate: null,
    activeDate: null,
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    expiryDate: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: null,
    representativeIssuedOn: '',
    status: true,
    version: null,
    birthday: null,
    sex: '',
    files: [],
    adminUser: '',
    addresses: [this.defaultAddress],
    attachments: [],
    parentName: '',
    businessType: null
  };

  addresses = {
    cityName: '',
    districtName: '',
    wardName: ''
  };

  checkTax = true;
  customer = {
    id: null,
    enterpriseName: '',
    enterpriseId: localStorage.getItem('enterpriseId'),
    primaryEmail: null,
    customerType: 0,
    name: '',
    status: null,
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    taxCode: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: '',
    representativeIssuedAt: '',
    birthday: null,
    sex: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    phone: '',
    fax: '',
    email: '',
    address: '',
    cityId: null,
    wardId: null,
    districtId: null,
    attachments: [],
    adminUser: '',
    hasPermission: true,
    attachmentImages: []
  };

  isEnoughImage: boolean = false;
  title: string = '';
  pdfSrc: string;
  enterpriseName: string = '';
  private tenantId: string;
  private hashKey: string;
  checkFocus = true;
  checkAgree =false
  enterprises = this.defaultEnterprises;
  cities: comboBox[] = [];
  districts: districtsComboBox[] = [];
  selectedDistricts: districtsComboBox[] = [];
  wards: wardsCombobox[] = [];
  selectWards: wardsCombobox[] = [];
  enterpriseId: string;
  listFiles: any[] = [];
  maxSizeInput = false;
  error = '';
  show = true;
  change = false;
  subscription: Subscription;
  formChangesSubscription: Subscription;
  @ViewChild('f', { static: false }) ngForm: NgForm;
  @ViewChild('certificateNoEl', { static: false }) certificateNoEl: ElementRef;
  @ViewChildren('focusInput') focusInput;

  isFormChanging = false;
  enterpriseType: comboBox[] = [];
  certificateType: comboBox[] = [];
  representativeCertificateType: comboBox[] = [];
  listBankName: comboBox[] = [];


  enterpriseTypeFilterCtrl: FormControl = new FormControl();
  certificationTypeFilterCtrl: FormControl = new FormControl();
  representativeCertificateTypeFilterCtrl: FormControl = new FormControl();
  cityFilterCtrl: FormControl = new FormControl();
  districtsFilterCtrl: FormControl = new FormControl();
  wardFilterCtrl: FormControl = new FormControl();
  bankFilterCtrl: FormControl = new FormControl();


  public filteredWard: ReplaySubject<wardsCombobox[]> = new ReplaySubject<wardsCombobox[]>(1);
  public filteredDistricts: ReplaySubject<districtsComboBox[]> = new ReplaySubject<districtsComboBox[]>(1);
  public filteredCity: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredEnterpriseType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredCertificationType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredRepresentativeCertificateType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredBankName: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  private _onDestroy = new Subject<void>();

  /**
   * Check req expiredDateChange
   */
  checkIssuedDate = false;

  /**
   * Check if District hasn't Ward
   */
  notHasWard = false;

  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  constructor(
    private el: ElementRef,
    private enterpriseService: EnterpriseService,
    private apiService: ApiService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public message: Message,
    private breadcrumbsService: BreadcrumbsService,
    private toastr: ToastrService,
    private router: Router,
    public customerFilter: CustomerFilterLanguage,
    private kycService: KycService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
  ) {
    super(commonService, message);
  }

  ngOnInit() {
    this.enterpriseTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.enterpriseType, this.enterpriseTypeFilterCtrl, this.filteredEnterpriseType); });
    this.certificationTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.certificateType, this.certificationTypeFilterCtrl, this.filteredCertificationType); });
    this.representativeCertificateTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.representativeCertificateType, this.representativeCertificateTypeFilterCtrl, this.filteredRepresentativeCertificateType); });
    this.cityFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.cities, this.cityFilterCtrl, this.filteredCity); });
    this.districtsFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.selectedDistricts, this.districtsFilterCtrl, this.filteredDistricts); });
    this.wardFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => { this.commonService.filterCertificateType(this.selectWards, this.wardFilterCtrl, this.filteredWard); });
    this.bankFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.commonService.filterCertificateType(this.listBankName, this.bankFilterCtrl, this.filteredBankName);
    });
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.getBankName();
    this.getCertificateType();
    this.getEnterpriseType();
    this.getRepresentativeCertificateType();
    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
    });

    // this.loadData(this.enterpriseId);
    // this.loadCities();
    // this.loadDistricts();
    // this.loadWards();
    this.commonService.getCategory().subscribe(result => {
      this.cityList[1] = result[0].data.filter(item => !item.isNew)
      this.districtList[1] = result[1].data.filter(item => !item.isNew)
      this.wardList[1] = result[2].data.filter(item => !item.isNew)
      this.cityList[0] = result[3].data
      this.districtList[0] = []
      this.wardList[0] = result[4].data;
      this.cities = result[0].data;

      this.districts = result[1].data;
      this.wards = result[2].data;
      this.filteredCity.next(this.cities.slice());
      this.loadData(this.enterpriseId);
    });
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
    this.breadcrumbsService.store([
      { label: 'breadcrumbs.home', url: 'main', params: [], highlight: false },
      { label: 'breadcrumbs.enterprise_info', url: '', params: [], highlight: false },
      { label: 'update_enterprise.screen_name_new', url: '', params: [], highlight: false },
    ]);
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.formChangesSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Save data
   */
  // onCLickButtonSave() {
  //   if (this.isFormChanging || this.uploadMultiFileComponent.isFormChanging) {
  //     const dialogRef = this.dialog.open(WarningComponent, {
  //       width: '370px',
  //       // Them ten doanh nghiep
  //       data: this.commonService.format(this.message.getMessage('messages.confirm_update_enterprise'), this.oldEnterpriseName)
  //     });
  //     dialogRef.afterClosed().subscribe(rs => {
  //       if (rs) {
  //         this.uploadMultiFileComponent.uploadFile((attachments) => {
  //           this.enterprises.attachments = attachments;
  //           this.updateEnterprise(dialogRef);
  //         }, () => {
  //           this.updateEnterprise(dialogRef);
  //         });
  //       }
  //     });
  //   }
  // }

  /**
   * Call api to get customer by id
   * @param id: number
   */
   getCustomer() {
    const body = {
      hashKey: this.hashKey,
      tenantId: this.tenantId
    }
    this.customerService.getDetailCustomer(body).subscribe(
      rs => {
        if (rs == null || rs.data == null) {
          return 0;
        }
        this.customer = {
          ...this.customer,
          ...rs.data,
          issuedDate: rs.data.issuedDate != null ? new Date(rs.data.issuedDate) : null,
          representativeIssuedDate: rs.data.representativeIssuedDate != null ? new Date(rs.data.representativeIssuedDate) : null,
          birthday: rs.data.birthday != null ? new Date(rs.data.birthday) : null
        };
        if(this.customer.attachmentImages && this.customer.attachmentImages.length == 3){
          this.isEnoughImage = true
        }
        this.title = this.commonService.format(
          this.message.getMessage('kyc.note_inconrect_info'), this.customer.enterpriseName);
        this.getEnterpriseType();
        this.loadData(this.customer.enterpriseId);

        // var cityItem = (this.customer.cityId != null) ? this.cities.find(x => x.id === this.customer.cityId) : undefined;
        // var districtItem = (this.customer.districtId != null) ? this.districts.find(x => x.id === this.customer.districtId) : undefined;
        // var wardItem = (this.customer.wardId != null) ? this.wards.find(x => x.id === this.customer.wardId) : undefined;
        this.addresses = {
          cityName: (this.customer.cityId != null) ? this.cities.find(x => x.id === this.customer.cityId).name : '',
          districtName: (this.customer.districtId != null) ? this.districts.find(x => x.id === this.customer.districtId).name : '',
          wardName: (this.customer.wardId != null) ? this.wards.find(x => x.id === this.customer.wardId).name : '',
        };
        this.getCertificateType();
        this.getRepresentativeCertificateType();
        this.viewDocumentUpload();
      }
    );
  }

  viewDocumentUpload() {
    const body = {
      hashKey: this.hashKey,
      tenantId: this.tenantId
    }
    this.kycService.verifyCustomerGetPdf(body).subscribe(res => {
      this.showPdf(res);
    });
  }

  showPdf(blob: any) {
    const file = this.blobToFile(blob, 'application/pdf');
    this.commonService.readFile(file, (pdfSrc) => {
      this.pdfSrc = pdfSrc;
    });
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  }


  //ký số
  onSign() {
  localStorage.setItem('tempEnterprise', JSON.stringify(this.enterprises));

  this.kycService.verifyNewAccountGetPdf(this.enterprises).subscribe(res => {
    if (!res) return;

    // 1. Kiểm tra nếu là lỗi (Blob có type là application/json)
    if (res.type === 'application/json') {
      const reader = new FileReader();

      // Khi nào đọc xong file thì chạy hàm này
      reader.onload = () => {
  const fullText = reader.result as string;

  try {
    // 1. Tìm vị trí bắt đầu của JSON mã hóa Base64 (luôn bắt đầu bằng "eyJ")
    const base64Part = fullText.substring(fullText.indexOf('eyJ'));

    // 2. Giải mã Base64 sang chuỗi JSON thuần
    // Dùng cách này để xử lý triệt để lỗi font tiếng Việt (MÃ£ sá»‘ -> Mã số)
    const decodedText = decodeURIComponent(atob(base64Part).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    // 3. Ép kiểu về Object để lấy message
    const result = JSON.parse(decodedText);

    // 4. Hiển thị Toastr
    this.toastr.error(result.message);

  } catch (error) {
    console.error("Lỗi giải mã Base64 hoặc Parse JSON:", error);
    this.toastr.error("Có lỗi xảy ra, vui lòng thử lại!");
  }
};

      reader.readAsText(res); // Bắt đầu đọc
      return; // Dừng hàm onSign, không cho chạy xuống phần PDF/Chuyển trang bên dưới
    }

    // 2. Nếu không phải lỗi (là PDF thật), thực hiện tiếp logic thành công
    this.showPdf(res);
    this.router.navigate(['/home-enterprise/kyc-confirm-account-review-enterprise']);

  });
}
  //ekyc
  onKycCamera() {
    const message = this.commonService.format(this.message.getMessage('messages.ekyc_must_be_on_phone'));
    const dialogRe = this.dialog.open(AlertEkycComponent, {
      width: '600px',
      data: message,
    });
    dialogRe.afterClosed().subscribe((rs) => {
      if (rs) {
        console.log("close")
      }
    });
  }

  /**
   * Call update enterprise service and push data to server.
   * @param dialogRe: Dialog result confirmation.
   */
  private updateEnterprise(dialogRe) {
    this.enterpriseService.updateEnterprise(
      this.enterprises.id, this.enterprises,
      () => {
        this.show = false;
        this.toastr.success(this.message.getMessage('messages.update_success'));
        this.loadData(this.enterpriseId);

        // Update changing status of form/attachment after save successfully
        this.ngForm.form.markAsPristine();
        this.uploadMultiFileComponent.setFormChanging(false);
      },
      () => {
        this.loadData(this.enterpriseId);
      },
      this.onUpdateEnterpriseError.bind(this)
    );
  }

  private onUpdateEnterpriseError(rs: any) {
    if (!rs.success) {
      switch (rs.code) {
        case '0x00118':
          this.certificateNoExistingHanlder(rs);
          break;
        case '0x00117':
          this.taxNoExistingHanlder(rs);
          break;
        default:
          this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
          break;
      }
    }
  }

  private certificateNoExistingHanlder(rs: any): void {
    this.ngForm.form.controls.certificateNo.setErrors({ incorrect: true, duplicate: true });
    Utils.forcusAndScrollToElement(this.certificateNoEl);
  }
  private taxNoExistingHanlder(rs: any): void {
    this.ngForm.form.controls.taxCode.setErrors({ incorrect: true, duplicate: true });
    document.getElementById('taxCodeid').focus();
  }

  /**
   * Load data when init
   */
  loadData(enterpriseId: string) {
    this.enterpriseService.getEnterpriseByID(enterpriseId).subscribe(rs => {
      if (rs != null && rs.data != null) {
        const responsedData = rs.data;
        this.oldEnterpriseName = responsedData.name;
        this.enterpriseName = rs.data.name
        if (responsedData.addresses == null || responsedData.addresses.length == 0) {
          responsedData.addresses = [this.defaultAddress];
        }
        this.enterprises = responsedData;
        localStorage.setItem('checkTax', JSON.stringify(true));
        //this.enterprises.taxCode = '';
        if(this.enterprises.taxCode == '' || this.enterprises.taxCode == null){
          localStorage.setItem('checkTax', JSON.stringify(false));
          this.checkTax = false;
        }
        this.enterprises.files = [];
        // this.enterprises.issuedDate = new Date(rs.data.issuedDate);
        if (this.enterprises.issuedDate != null) {
          this.enterprises.issuedDate = new Date(rs.data.issuedDate);
        } else {
          this.enterprises.issuedDate = null;
        }
        if (this.enterprises.representativeIssuedDate != null) {
          this.enterprises.representativeIssuedDate = new Date(rs.data.representativeIssuedDate);
        } else {
          this.enterprises.representativeIssuedDate = null;
        }
        if (this.enterprises.birthday != null) {
          this.enterprises.birthday = new Date(rs.data.birthday);
        } else {
          this.enterprises.birthday = null;
        }
        this.enterprises.addresses[0].isNewAddress = !!responsedData.addresses[0].isNewAddress
        if(this.enterprises.addresses[0].isNewAddress){
          this.cities = this.cityList[0]
          this.districts = this.districtList[0]
          this.wards = this.wardList[0]
        } else {
          this.cities = this.cityList[1]
          this.districts = this.districtList[1]
          this.wards = this.wardList[1]
        }
        this.filteredCity.next(this.cities.slice());
        if(!this.enterprises.addresses[0].isNewAddress){
          this.selectedDistricts = this.districts.filter(x => {
            return x.cityId == this.enterprises.addresses[0].cityId;
          });
          this.filteredDistricts.next(this.selectedDistricts.slice());
          this.selectWards = this.wards.filter(x => {
            return x.districtId == this.enterprises.addresses[0].districtId;
          });
          this.filteredWard.next(this.selectWards.slice());
        } else {
          this.selectWards = this.wards.filter(x => {
            return  x.cityId == this.enterprises.addresses[0].cityId;
          });
          this.filteredWard.next(this.selectWards.slice());
        }
      } else {
        this.enterprises = this.defaultEnterprises;
      }
      this.uploadMultiFileComponent.maxSizeInput = false;
      this.getEnterpriseType();
    });
  }

  /**
   * Load all cites
   */
  loadCities() {
    // if (localStorage.getItem('cities') === null) {
      this.getCitiesRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.cities = data;
          localStorage.setItem(
            'cities',
            JSON.stringify(this.cities),
          );
          this.filteredCity.next(this.cities.slice());
        }
      });
    // } else {
    //   this.cities = JSON.parse(
    //     localStorage.getItem('cities')
    //   );
    //   this.filteredCity.next(this.cities.slice());
    // }
  }

  /**
   * Load all districts
   */
  loadDistricts() {
    // if (localStorage.getItem('districts') === null) {
      this.getDistrictsRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.districts = data;
          localStorage.setItem(
            'districts',
            JSON.stringify(this.districts),
          );
        }
      });
    // } else {
    //   this.districts = JSON.parse(
    //     localStorage.getItem('districts')
    //   );
    // }
  }

  /**
   * Load all ward
   */
  loadWards() {
    // if (localStorage.getItem('wards') === null) {
      this.getWardsRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.wards = data;
          localStorage.setItem(
            'wards',
            JSON.stringify(this.wards),
          );
        }
      });
    // } else {
    //   this.wards = JSON.parse(
    //     localStorage.getItem('wards')
    //   );
    // }
  }

  onlyTaxChars(event: KeyboardEvent): boolean {
    const charCode = event.key;
    // Cho phép số (0-9) và dấu gạch ngang (-)
    const regex = /[0-9-]/;

    if (!regex.test(charCode)) {
      event.preventDefault(); // Chặn ký tự không hợp lệ
      return false;
    }
    return true;
  }
  /**
   * Handle event when change select
   */
  onChange(value: number, opt: number = 1) {
    switch (opt) {
      case 1:
        this.selectedDistricts = this.districts.filter(x => {
          this.selectWards = null;
          this.enterprises.addresses[0].districtId = null;
          this.enterprises.addresses[0].wardId = null;
          return x.cityId == value;
        });
        this.filteredDistricts.next(this.selectedDistricts.slice());
        this.filteredWard = new ReplaySubject<wardsCombobox[]>(1);
        break;
      case 2:
        this.selectWards = this.wards.filter(x => {
          this.enterprises.addresses[0].wardId = null;
          if(this.enterprises.addresses[0].isNewAddress){
            return x.cityId === value;
          } else {
            return x.districtId === value;
          }
        });
        this.filteredWard.next(this.selectWards.slice());
        if (this.selectWards.length === 0) {
          this.notHasWard = true;
        } else {
          this.notHasWard = false;
        }
        break;
      default:

        break;
    }
  }

  /**
   * Handle when click button Back to Home
   */
  onNoClick() {
    // if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '370px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          localStorage.removeItem('tempEnterprise')
          this.router.navigate(['/home-enterprise/view-enterprise']);
        }
        dialogRe.close();
      });
    // } else {
    //   this.router.navigate(['/home-enterprise/view-enterprise']);
    // }

  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    const tenantId = localStorage.getItem('tenantId');
    if ((this.isFormChanging && this.show && tenantId != null)
      || (this.uploadMultiFileComponent.isFormChanging && this.show && tenantId != null)
      || (this.change && this.show && tenantId != null)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '370px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.change = true;
  }

  /**
   * Get wards list from local storage or api
   */
  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.enterpriseType = result;
        this.filteredEnterpriseType.next(this.enterpriseType.slice());
      }
    });
  }

  /**
   * Get certificate list
   */
  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.certificateType = result;
        this.filteredCertificationType.next(this.certificateType.slice());
      }
    });
  }

  /**
   * Get representative certificate list
   */
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.representativeCertificateType = result;
        this.filteredRepresentativeCertificateType.next(this.representativeCertificateType.slice());
      }
    });
  }

  getBankName() {
    this.commonService.getBankName().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.listBankName = result;
        this.filteredBankName.next(this.listBankName.slice());
      }
    });
  }

  /**
   * Check req for checkIssuedDate
   */
  checkIssuedDateChange(value) {
    if (value == null || value == '' || value == undefined) {
      this.checkIssuedDate = true;
    } else {
      this.checkIssuedDate = false;
    }
  }
  /**
   * Handle attachment form status change
   */
  onAttachmentChange(event) {
    this.isFormChanging = event;
  }
  getEnterpriseTypeOptions(options) {
    return this.customerFilter.filterOptionsData(options);
  }

  cityList: any[] = []
  districtList: any[] = []
  wardList: any[] = []

  changeAddress(event: boolean){
    if(this.enterprises.addresses[0].isNewAddress == event){
      return
    }
    this.enterprises.addresses[0].isNewAddress = event
    console.log(event);

    if(event){
      this.cities = this.cityList[0]
      this.districts = this.districtList[0]
      this.wards = this.wardList[0]
      if(!(!this.enterprises.addresses[0].cityId && !this.enterprises.addresses[0].districtId && !this.enterprises.addresses[0].wardId)){
        this.blockUI.start()
        const id = this.enterprises.addresses[0].wardId ? this.enterprises.addresses[0].wardId : this.enterprises.addresses[0].districtId ? this.enterprises.addresses[0].districtId : this.enterprises.addresses[0].cityId
        this.enterprises.addresses[0].cityId = null
        this.enterprises.addresses[0].districtId = null
        this.enterprises.addresses[0].wardId = null
        this.onChange(null, 2)
        this.commonService.changeNewAddress(id).pipe(finalize(()=> this.blockUI.stop())).subscribe(res =>{
          console.log(res, res.data._return.lstProductSpecCharDTOs);
          if(res.success){
            if(res.data._return.lstProductSpecCharDTOs && res.data._return.lstProductSpecCharDTOs.length > 0){
              this.enterprises.addresses[0].cityId = res.data._return.lstProductSpecCharDTOs[0].province;
              this.onChange(this.enterprises.addresses[0].cityId, 2)
              if(res.data._return.lstProductSpecCharDTOs[0].precinct){
                this.enterprises.addresses[0].wardId = this.enterprises.addresses[0].cityId + res.data._return.lstProductSpecCharDTOs[0].precinct;
              }
            }
          } else {
            this.toastr.error(res.message)
          }
        })
      } else {
        this.onChange(null, 2)
      }
    } else {
      this.cities = this.cityList[1]
      this.districts = this.districtList[1]
      this.wards = this.wardList[1]
      this.enterprises.addresses[0].cityId = null
      this.enterprises.addresses[0].districtId = null
      this.enterprises.addresses[0].wardId = null
      this.onChange(null)
    }
    this.cityFilterCtrl.patchValue('')
    this.districtsFilterCtrl.patchValue('')
    this.wardFilterCtrl.patchValue('')
  }

  onlyNumber(event: Event): void {
    const input = event.target as HTMLInputElement;
  
    input.value = input.value.replace(/[^0-9]/g, '');
    this.enterprises.accountNumber = input.value;
  }
}

